import _extends from "@babel/runtime/helpers/esm/extends";
import { createSelector, createSelectorMemoized } from '@base-ui/utils/store';
import { DEFAULT_SCHEDULER_PREFERENCES } from "../internals/utils/SchedulerStore/index.mjs";
const allSchedulerPreferencesSelector = createSelectorMemoized(state => state.preferences, preferences => _extends({}, DEFAULT_SCHEDULER_PREFERENCES, preferences));
export const schedulerPreferenceSelectors = {
  all: allSchedulerPreferencesSelector,
  ampm: createSelector(allSchedulerPreferencesSelector, preferences => preferences.ampm)
};